let LogUser = {
    insertLog: "/api/LogUser/insertLog",
    queryByCondition:"/api/LogUser/queryByCondition"
};

export default LogUser;
